import React, { useContext } from "react";

export const useGlobalDataContext = () => useContext(GlobalDataContext);
const GlobalDataContext = React.createContext({});
export default GlobalDataContext;